import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import About from "./component/pages/About";
import Home from "./component/pages/Home";
import Product from "./component/pages/Product";
import Service from "./component/pages/Service";
import Career from "./component/pages/Career";
import Comercio from "./component/pages/Comercio";
import Contact from "./component/pages/Contact";
import Event from "./component/pages/Event";
import Intern from "./component/pages/Intern";
import Personal from "./component/page_content/Intern_form/Personal_info";
import PageNotFound from "./component/Common/PageNotFound";
import Main from "./component/pages/Main";
import Medico from "./component/pages/Medico";
import Truck from "./component/pages/Truck";
import Education from "./component/pages/Education";
import Examen from "./component/pages/Examen";
import Realstate from "./component/pages/Realstate";
import SubService from "./component/page_content/SubService";
import Webservice from "./component/page_content/Webservice";
import { Logo_branding } from "./component/page_content/Logo_branding";
import { Android } from "./component/page_content/Android";
import { Ios_app } from "./component/page_content/Ios_app";
import { Ai } from "./component/page_content/Ai";
import { It_cs } from "./component/page_content/It_cs";
import { Dm } from "./component/page_content/Dm";
// require('dotenv').config()
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/product" element={<Product />} />
          <Route path="/service" element={<Service />} />
          {/* <Route path="/service/:id" element={<SubService />} /> */}
          <Route path="/service/8" element={<SubService />} />
          <Route path="/service/1" element={<Webservice />} />
          <Route path="/service/2" element={<Logo_branding />} />
          <Route path="/service/3" element={<Android />} />
          <Route path="/service/4" element={<Ios_app />} />
          <Route path="/service/5" element={<Ai />} />
          <Route path="/service/6" element={<It_cs />} />
          <Route path="/service/7" element={<Dm />} />
          <Route path="/career" element={<Career />} />
          <Route path="/comercio/:id" element={<Comercio />} />
          <Route path="/medico/2" element={<Medico />} />
          <Route path="/truck/3" element={<Truck />} />
          <Route path="/education/4" element={<Education />} />
          <Route path="/examen/5" element={<Examen />} />
          <Route path="/realstate/5" element={<Realstate />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/event" element={<Event />} />
          <Route path="/internship" element={<Intern />} />
          <Route path="/personal_info" element={<Personal />} />
          <Route path="/maininvoice" element={<Main />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
